import { render, staticRenderFns } from "./tele-health-v2.vue?vue&type=template&id=276f3624&scoped=true&"
import script from "./tele-health-v2.vue?vue&type=script&lang=js&"
export * from "./tele-health-v2.vue?vue&type=script&lang=js&"
import style0 from "../../../public/static/fonts.scss?vue&type=style&index=0&id=276f3624&scoped=true&lang=scss&"
import style1 from "./tele-health-v2.vue?vue&type=style&index=1&id=276f3624&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276f3624",
  null
  
)

component.options.__file = "tele-health-v2.vue"
export default component.exports